{
  "cp.components.appDrawer.drawerCourses": "Cours",
  "cp.components.appDrawer.drawerExport": "Export",
  "cp.components.appDrawer.drawerImprint": "Conditions",
  "cp.components.appDrawer.drawerInstitutes": "Instituts",
  "cp.components.appDrawer.drawerSettings": "Paramètres",
  "cp.components.appDrawer.drawerShares": "Partages",
  "cp.components.appDrawer.drawerSingleTrainings": "Entraînements",
  "cp.components.appDrawer.drawerTrainees": "Stagiaires",
  "cp.components.appDrawer.drawerTrainers": "Formateurs",
  "cp.components.changePassword.changePasswordButton": "Changer le mot de passe",
  "cp.components.changePassword.currentPassword": "Mot de passe actuel",
  "cp.components.changePassword.equalError": "Le nouveau mot de passe est le même que l'ancien",
  "cp.components.changePassword.matchError": "Les nouveaux mots de passe ne correspondent pas",
  "cp.components.changePassword.newPassword": "Nouveau mot de passe",
  "cp.components.changePassword.newPasswordRepeat": "Nouveau mot de passe (répéter)",
  "cp.components.changePassword.newRequiredError": "Un nouveau mot de passe est requis",
  "cp.components.changePassword.newToShortError": "Le mot de passe fourni est trop court.",
  "cp.components.changePassword.requiredError": "Le mot de passe actuel est requis",
  "cp.components.changePassword.setPasswordButton": "Définir le mot de passe",
  "cp.components.changeUserRole.errorSnackbar": "Une erreur inconnue s'est produite. Veuillez réessayer ou contacter le support si l'erreur persiste.",
  "cp.components.changeUserRole.selectLabel": "Choisir rôle",
  "cp.components.changeUserRole.successSnackbar": "Rôle changé en {role}",
  "cp.components.courseTable.deleteLabel": "supprimer",
  "cp.components.courseTable.downloadCSVTitle": "Télécharger le fichier CSV",
  "cp.components.courseTable.downloadMessage": "Cours sélectionné pour téléchargement",
  "cp.components.courseTable.selected": "Sélectionné",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Formateur Associé",
  "cp.components.courseTable.tableRowDate": "Date",
  "cp.components.courseTable.tableRowIdentifier": "ID du cours",
  "cp.components.courseTable.tableRowLocation": "Localisation",
  "cp.components.courseTable.tableRowProvider": "Fournisseur de Entraînement",
  "cp.components.courseTable.tableRowTraineeCount": "Nombre de stagiaires",
  "cp.components.courseTable.tableRowValue": "Valeur",
  "cp.components.dialog.confirmDeletion.contentConclusion": "La suppression est définitive. Ce compte ne sera plus disponible.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Vous êtes sur le point de supprimer un compte avec le ou les rôles suivants :",
  "cp.components.dialog.confirmDeletion.title": "Supprimer le compte sélectionné ?",
  "cp.components.footer.rightsReserved": "Tous droits réservés.",
  "cp.components.general.institutePageSnackbarError": "Erreur lors de l'enregistrement de l'institut",
  "cp.components.general.institutePageSnackbarSuccess": "Enregistré",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "L'E-mail a été envoyé au cours des 10 dernières minutes. Veuillez patienter avant de pouvoir en envoyer un autre.",
  "cp.components.general.tableRowName": "Nom",
  "cp.components.genericTable.emptyMessage": "Vide",
  "cp.components.genericTable.multiSelect": "Sélectionner tout",
  "cp.components.genericTable.nextPage": "page suivante",
  "cp.components.genericTable.previousPage": "page précédente",
  "cp.components.genericTable.rowsPerPageLabel": "Lignes par page:",
  "cp.components.genericTable.searchPlaceholder": "Rechercher",
  "cp.components.imprint.pageTitle": "Conditions",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Invitez l'Administrateur",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Utilisateurs autorisés à gérer l'institut",
  "cp.components.instituteAdminTable.adminsTableTitle": "Administrateurs",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Voulez-vous vraiment supprimer l'administrateur sélectionné ? Ce sera permanent.",
  "cp.components.instituteAdminTable.deleteLabel": "Supprimer",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Voulez-vous vraiment supprimer le formateur sélectionné ? Ce sera permanent.",
  "cp.components.instituteAdminTable.name": "Nom",
  "cp.components.instituteAdminTable.selected": "sélectionné",
  "cp.components.instituteForm.institute": "Institut",
  "cp.components.instituteForm.instituteAddress": "Adresse de l'institut",
  "cp.components.instituteForm.instituteCity": "Ville",
  "cp.components.instituteForm.instituteCountry": "Pays",
  "cp.components.instituteForm.instituteName": "Nom de l'institut",
  "cp.components.instituteForm.instituteSaveButton": "Enregistrer",
  "cp.components.instituteForm.instituteState": "État",
  "cp.components.instituteForm.instituteStreet": "Rue et numéro de maison",
  "cp.components.instituteForm.instituteStreetAdditional": "Ajout à l'adresse",
  "cp.components.instituteForm.instituteZIP": "Code postal",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "English",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "English",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Langue",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Configurer la rétroaction des résultats",
  "cp.components.instituteResultConfig.info": "Ces modifications s'appliquent à l'ensemble de l'institut. Pour ce faire, les formateurs doivent se reconnecter à l'application CorPatch® Trainer. ",
  "cp.components.instituteResultConfig.save": "Enregistrer la configuration",
  "cp.components.instituteResultConfig.thresholdGood": "Seuil Bon",
  "cp.components.instituteResultConfig.thresholdGreat": "Seuil Excellent",
  "cp.components.instituteTrainerTable.button": "Inviter le formateur",
  "cp.components.instituteTrainerTable.deleteLabel": "supprimer",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "sélectionné",
  "cp.components.instituteTrainerTable.subtitle": "Tous les formateurs appartenant à l'institut\n",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Rue",
  "cp.components.instituteTrainerTable.title": "Formateurs",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Pas encore de formateurs",
  "cp.components.invite.inviteCancelButton": "Annuler",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Envoyé",
  "cp.components.invite.inviteEmailSent": "E-mail envoyé.",
  "cp.components.invite.inviteFirstnameLabel": "Prénom",
  "cp.components.invite.inviteInvalidEmail": "Cette adresse E-mail n'est pas valide",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Envoyer l'invitation",
  "cp.components.invite.inviteSubheader": "Une invitation sera envoyée à cette adresse E-mail.",
  "cp.components.invite.inviteSurnameLabel": "Nom de famille",
  "cp.components.navBar.menuLabel": "menu",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Changer le Mot de passe",
  "cp.components.passwordForgotSetPassword.matchError": "Les nouveaux mots de passe ne correspondent pas",
  "cp.components.passwordForgotSetPassword.newPassword": "Nouveau mot de passe",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Nouveau mot de passe (répéter)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "Un nouveau mot de passe est requis",
  "cp.components.passwordForgotSetPassword.newToShortError": "Le mot de passe fourni est trop court.",
  "cp.components.reminder.app.appAppStoreButton": "Allez sur l'Apple App Store",
  "cp.components.reminder.app.appPlayStoreButton": "Allez sur Google Play Store",
  "cp.components.reminder.app.content": "Pour utiliser votre CorPatch®, vous avez besoin de l'application CorPatch®. Téléchargez-le sur Google Playstore ou App Store. \n",
  "cp.components.reminder.app.title": "Vous voulez commencer ? Téléchargez l'application !",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Bienvenue",
  "cp.components.resetPassword.changePasswordButton": "Changer le mot de passe",
  "cp.components.resetPassword.currentPassword": "Mot de passe actuel",
  "cp.components.resetPassword.equalError": "Le nouveau mot de passe est le même que l'ancien",
  "cp.components.resetPassword.matchError": "Les nouveaux mots de passe ne correspondent pas",
  "cp.components.resetPassword.newPassword": "Nouveau mot de passe",
  "cp.components.resetPassword.newPasswordRepeat": "Nouveau mot de passe (répéter)",
  "cp.components.resetPassword.newRequiredError": "Un nouveau mot de passe est requis",
  "cp.components.resetPassword.requiredError": "Le mot de passe actuel est requis",
  "cp.components.resetPassword.setPasswordButton": "Définir le mot de passe",
  "cp.components.singleTrainingsTable.shareDialogContent": "Sélectionnez l'institut avec lequel vous souhaitez partager cette formation :",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Partagez la formation",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Partagez la formation",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Annuler",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Partager",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Partagé le: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Date",
  "cp.components.singleTrainingsTable.tableRowDepth": "Profondeur",
  "cp.components.singleTrainingsTable.tableRowFlow": "Flux",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Fréquence",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Entraînement",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Relâchement",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Partagez la formation",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Déconnexion",
  "cp.components.userMenu.password": "Mot de passe",
  "cp.pages.acceptInvitation.button": "Vers la page de connexion",
  "cp.pages.acceptInvitation.message": "Tout est prêt et vous êtes prêt à partir !",
  "cp.pages.acceptInvitation.pageNotFound.message": "Cette invitation n'est plus valable.",
  "cp.pages.acceptInvitation.pageNotFound.title": "Invitation non trouvée",
  "cp.pages.acceptInvitation.title": "Fini.",
  "cp.pages.acceptInvitation.welcome": "Bienvenue",
  "cp.pages.adminInvite.errorSnackbar": "L'E-mail {email} est déjà utilisé",
  "cp.pages.adminInvite.inviteCardTitle": "Inviter l'administrateur",
  "cp.pages.adminInvite.successSnackbar": "Envoyer un E-mail à {email}",
  "cp.pages.admins.adminsEmpty.button": "Inviter l'administrateur",
  "cp.pages.admins.adminsEmpty.message": "Voulez-vous inviter le premier administrateur de l'institut ?",
  "cp.pages.admins.adminsEmpty.selected": "sélectionné",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "E-mail",
  "cp.pages.admins.adminsEmpty.tableRowName": "Nom",
  "cp.pages.admins.adminsEmpty.title": "Pas encore d’administrateurs !",
  "cp.pages.admins.adminsNotFound.message": "Cet institut a été supprimé. ",
  "cp.pages.admins.adminsNotFound.title": "Non trouvé !",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Institut",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Date",
  "cp.pages.course.cellDuration": "Durée",
  "cp.pages.course.cellFeedback": "Mode de rétroaction",
  "cp.pages.course.cellName": "Nom",
  "cp.pages.course.rowDepth": "Profondeur",
  "cp.pages.course.rowFlow": "Flux",
  "cp.pages.course.rowFrequency": "Fréquence",
  "cp.pages.course.rowRecoil": "Relâchement",
  "cp.pages.course.title": "Cours",
  "cp.pages.course.trainees": "Stagiaires",
  "cp.pages.courses.errorSnackbar": "Ce cours n'a pas pu être supprimé.",
  "cp.pages.courses.pageNotFoundMessage": "A été supprimé. Désolé :(",
  "cp.pages.courses.pageNotFoundTitle": "non trouvé",
  "cp.pages.courses.pageTitle": "Cours",
  "cp.pages.courses.roleInstituteAdmin": "Administrateur de l'Institut",
  "cp.pages.courses.roleTrainee": "Stagiaire",
  "cp.pages.courses.successSnackbar": "Le cours a été supprimé avec succès.",
  "cp.pages.dashboard.cpsCount": "appareils CorPatch® actifs",
  "cp.pages.dashboard.cpsCountRecently": "nouveau CorPatch® connecté",
  "cp.pages.dashboard.lastMonth": "Évolution au cours du dernier mois.",
  "cp.pages.dashboard.mobilesCount": "Tous les mobiles reconnus",
  "cp.pages.dashboard.mobilesCountRecently": "mobiles récents",
  "cp.pages.dashboard.pageTitle": "Statistiques",
  "cp.pages.dashboard.trainingsCount": "formations terminées",
  "cp.pages.dashboard.usersCount": "nombre total d'utilisateurs enregistrés",
  "cp.pages.dashboard.usersCountRecently": "nouveaux utilisateurs enregistrés",
  "cp.pages.email.validation.button": "Aller à la Connexion",
  "cp.pages.email.validation.text": "Merci d'avoir vérifié votre adresse E-mail. Nous l'utiliserons pour sécuriser votre compte et vous tenir au courant si vous le souhaitez.",
  "cp.pages.export.pageTitle": "Cours d'exportation",
  "cp.pages.homepage.title": "Page d'Accueil",
  "cp.pages.institute.PageNotFound.message": "Cet institut a été supprimé et ne peut plus être modifié.",
  "cp.pages.institute.PageNotFound.title": "Institut non trouvé.",
  "cp.pages.institute.institute": "Institut",
  "cp.pages.institute.snackbarError": "Erreur lors de l'enregistrement de l'institut",
  "cp.pages.institute.snackbarSuccess": "Enregistré",
  "cp.pages.institute.tabsAdmins": "Administrateurs",
  "cp.pages.institute.tabsBaseData": "Données de base",
  "cp.pages.institute.tabsTrainers": "Formateurs",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Fin : ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "Vous n'avez aucun objet de partage actif.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "Aucun objet de partage supprimé.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "Les actions que vous recherchez n'existent pas.",
  "cp.pages.instituteAdminShares.pageTitle": "Partages",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Introuvable",
  "cp.pages.instituteAdminShares.startDate": "Début : ",
  "cp.pages.institutes.addInstituteButton": "Ajouter un institut",
  "cp.pages.institutes.deleteLabel": "supprimer",
  "cp.pages.institutes.errorSnackbar": "L'institut n'a pas pu être supprimé",
  "cp.pages.institutes.pageNotFound.message": "Voulez-vous ajouter le premier institut ?",
  "cp.pages.institutes.pageNotFound.title": "Aucun institut trouvé",
  "cp.pages.institutes.pageTitle": "Instituts",
  "cp.pages.institutes.successSnackbar": "L'institut a été supprimé avec succès",
  "cp.pages.institutesTable.deleteWarning": "Voulez-vous supprimer l'institut sélectionné ? Tous les comptes et données associés seront perdus !",
  "cp.pages.institutesTable.instituteLowercase": "institut",
  "cp.pages.institutesTable.institutesLowercase": "instituts",
  "cp.pages.institutesTable.tableRowCity": "Ville",
  "cp.pages.institutesTable.tableRowCountry": "Pays",
  "cp.pages.institutesTable.tableRowInstitutes": "Instituts",
  "cp.pages.institutesTable.tableRowName": "Nom",
  "cp.pages.institutesTable.tableRowStreet": "Rue",
  "cp.pages.institutesTable.tableRowZIP": "Code postal",
  "cp.pages.internalServerError.button": "Réessayer",
  "cp.pages.internalServerError.message": "Le serveur n'a pas été en mesure de compléter la requête. C'est notre faute. Veuillez réessayer plus tard.",
  "cp.pages.internalServerError.title": "Veuillez réessayer plus tard.",
  "cp.pages.login.email": "E-mail",
  "cp.pages.login.loginButton": "Connexion",
  "cp.pages.login.loginInstitutesTitle": "Instituts",
  "cp.pages.login.password": "Mot de passe",
  "cp.pages.login.passwordForgot": "Mot de passe oublié ?",
  "cp.pages.login.registerButton": "Enregistrer",
  "cp.pages.login.termsOfUseButton": "Conditions",
  "cp.pages.login.userNewlyRegisteredLabel1": "Vous avez été enregistré avec succès.",
  "cp.pages.login.userNewlyRegisteredLabel2": "N'oubliez pas de confirmer votre adresse E-mail et de vous connecter immédiatement.",
  "cp.pages.login.userOrPasswordNotFound": "Utilisateur ou mot de passe non trouvé",
  "cp.pages.login.validate.errorContent": "Vous avez peut-être essayé de vous connecter à partir d'un autre navigateur ou appareil ou vous avez fermé votre navigateur entre-temps. Essayez de demander un autre courriel pour vous connecter.",
  "cp.pages.login.validate.errorSnackbar": "Une erreur s'est produite lors de votre connexion. Votre lien est peut-être périmé.",
  "cp.pages.login.validate.errorTitle": "Nous n'avons pas pu reconnaître votre session de navigation",
  "cp.pages.login.validate.successContent": "Veuillez patienter un moment pendant que nous validons votre connexion.",
  "cp.pages.login.validate.successTitle": "Nous vous enregistrons.",
  "cp.pages.login.validate.validationButton": "Retourner à la connexion",
  "cp.pages.login.validate.validationContent": "Nous vous avons envoyé un E-mail pour vérifier votre connexion.",
  "cp.pages.login.validate.validationTitle": "Veuillez vérifier votre connexion",
  "cp.pages.logout.loginButton": "CONNEXION",
  "cp.pages.logout.message": "À la prochaine fois",
  "cp.pages.logout.title": "Au revoir !",
  "cp.pages.me.deleteOwnButtonConfirm": "Supprimer définitivement votre compte",
  "cp.pages.me.deleteOwnButtonRequest": "Supprimer définitivement votre compte",
  "cp.pages.me.deleteOwnContent": "Cette action supprimera définitivement votre compte. Assurez-vous d'avoir sauvegardé toutes les données qui pourraient être perdues lors de la suppression de votre compte. Sachez que vous ne pouvez pas annuler cette action.",
  "cp.pages.me.familyName": "Nom de famille",
  "cp.pages.me.firstName": "Prénom",
  "cp.pages.me.gender": "Sexe",
  "cp.pages.me.genderFemale": "Femme",
  "cp.pages.me.genderMale": "Homme",
  "cp.pages.me.genderOther": "Autre",
  "cp.pages.me.notFoundTitle": "Paramètre personnel",
  "cp.pages.me.save": "Enregistrer",
  "cp.pages.me.snackBarSaved.error": "Erreur lors de l’enregistrement du paramètre personnel",
  "cp.pages.me.snackBarSaved.saved": "Enregistré",
  "cp.pages.me.title": "Paramètre personnel",
  "cp.pages.networkError.pageNotFound.button": "Réessayer",
  "cp.pages.networkError.pageNotFound.message": "Le serveur n'a pas été en mesure de répondre à la demande. Êtes-vous connecté à l'Internet ?",
  "cp.pages.networkError.pageNotFound.title": "Le serveur semble en panne. C'est pour nous ! Veuillez réessayer ultérieurement. ",
  "cp.pages.notFound.message": "Cette page est introuvable.",
  "cp.pages.notFound.title": "Non trouvé.",
  "cp.pages.passwordForgot.confirmationMessage": "L'e-mail de vérification sera envoyé à votre compte.",
  "cp.pages.passwordForgot.confirmationMessage2": "Veuillez le vérifier.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Nous vous avons envoyé un e-mail avec un lien d'approbation à",
  "cp.pages.passwordForgot.confirmationSent": "Envoyer e-mail",
  "cp.pages.passwordForgot.confirmationTitle": "Réinitialisez votre mot de passe",
  "cp.pages.passwordForgot.eMail": "E-mail",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Retour à la page de connexion",
  "cp.pages.passwordForgot.passwordForgotTitle": "Mot de passe oublié",
  "cp.pages.passwordForgotSetPassword.button": "Vers la page de connexion",
  "cp.pages.passwordForgotSetPassword.message": "Tout est prêt et vous êtes prêt à partir !",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Ce code n'est plus valable.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "N'est plus valable",
  "cp.pages.passwordForgotSetPassword.title": "Mot de passe changé !",
  "cp.pages.passwordForgotSetPassword.welcome": "Bienvenue",
  "cp.pages.register.acceptTermsOfUse": "Acceptez-vous les conditions d'utilisation ?",
  "cp.pages.register.create": "Créer un Compte",
  "cp.pages.register.emailField": "E-mail",
  "cp.pages.register.errorSnackbar": "Une erreur involontaire s'est produite. Veuillez réessayer.",
  "cp.pages.register.firstnameField": "Prénom",
  "cp.pages.register.lastnameField": "Nom de famille",
  "cp.pages.register.newToShortError": "Le mot de passe fourni est trop court.",
  "cp.pages.register.passwordField": "mot de passe",
  "cp.pages.register.successSnackbar": "Votre enregistrement a réussi.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Barre",
  "cp.pages.settings.feedbackMode.menuItemNone": "Aucun",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pompe",
  "cp.pages.settings.menuItemThresholdGood": "Seuil de Rétroaction \"Bon\"",
  "cp.pages.settings.menuItemThresholdGreat": "Seuil de Rétroaction \"Excellent\"",
  "cp.pages.settings.resultType.menuItemExpert": "Expert",
  "cp.pages.settings.resultType.menuItemNone": "Aucun",
  "cp.pages.settings.resultType.menuItemSimple": "Simple",
  "cp.pages.settings.resultType.menuItemStandard": "Standard",
  "cp.pages.settings.tableRowCompression": "Compressions seulement",
  "cp.pages.settings.tableRowDuration": "Durée de la session",
  "cp.pages.settings.tableRowERC": "Vérifiez les signes vitaux",
  "cp.pages.settings.tableRowFeedback": "Mode de rétroaction",
  "cp.pages.settings.tableRowFrequency": "Fréquence cible",
  "cp.pages.settings.tableRowLocked": "Verrouillé",
  "cp.pages.settings.tableRowProperty": "Propriété",
  "cp.pages.settings.tableRowResult": "Type de résultat",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Enregistrer la configuration des résultats",
  "cp.pages.settings.tableRowSaveButton": "Enregistrer",
  "cp.pages.settings.tableRowTrainees": "Nombre de stagiaires par défaut",
  "cp.pages.settings.tableRowType": "Type de session",
  "cp.pages.settings.tableRowValue": "Valeur",
  "cp.pages.settings.title": "Paramètres de CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "Accès à l'API",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Êtes-vous sûr de vouloir supprimer l'objet de partage ?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Cette action ne peut pas être annulée, mais aucune donnée ne sera perdue. L'objet de partage sera affiché comme étant désactivé.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Annuler",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Supprimer un objet de partage",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Supprimer",
  "cp.pages.sharingObject.form.deleteButton": "Supprimer",
  "cp.pages.sharingObject.form.disabled": "Désactivé",
  "cp.pages.sharingObject.form.enabled": "Activé",
  "cp.pages.sharingObject.form.invitationCode": "Code d'invitation",
  "cp.pages.sharingObject.form.invitationLink": "Lien d'invitation",
  "cp.pages.sharingObject.form.name": "Nom",
  "cp.pages.sharingObject.form.pullApiSecret": "Secret",
  "cp.pages.sharingObject.form.pullUrl": "URL d'extraction",
  "cp.pages.sharingObject.form.saveButton": "Enregistrer",
  "cp.pages.sharingObject.form.title": "Partage d'un objet",
  "cp.pages.sharingObject.form.webHook": "Webhook",
  "cp.pages.sharingObject.pageNotFoundDescription": "Les objets de partage que vous recherchez n'existent pas.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Introuvable",
  "cp.pages.sharingObject.pageTitle": "Partage d'objets",
  "cp.pages.sharingObject.snackBarDeleteError": "Impossible de supprimer",
  "cp.pages.sharingObject.snackBarDeleted": "Supprimé",
  "cp.pages.sharingObject.snackBarSaveError": "Impossible d'enregistrer",
  "cp.pages.sharingObject.snackBarSaved": "Enregistré",
  "cp.pages.singleTraining.multipleTrainings": "formations",
  "cp.pages.singleTraining.singleTraining": "entraînement",
  "cp.pages.singleTraining.table.created": "Créé",
  "cp.pages.singleTraining.table.name": "Nom Complet",
  "cp.pages.singleTraining.table.selected": "sélectionné",
  "cp.pages.singleTraining.title": "Vos formations",
  "cp.pages.trainee.cpsButton": "Télécharger les données CorPatch®",
  "cp.pages.trainee.delete.errorSnackbar": "Une erreur inconnue s'est produite",
  "cp.pages.trainee.delete.successSnackbar": "Stagiaires supprimés avec succès",
  "cp.pages.trainee.delete.warningSnackbar": "Un ou plusieurs utilisateurs n'ont pas été supprimés",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Supprimer",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Fermer",
  "cp.pages.trainee.deleteLabel": "supprimer",
  "cp.pages.trainee.mobileButton": "Télécharger les données du smartphone",
  "cp.pages.trainee.multipleTrainees": "stagiaires",
  "cp.pages.trainee.singleTrainee": "stagiaire",
  "cp.pages.trainee.table.created": "créé",
  "cp.pages.trainee.table.email": "E-mail",
  "cp.pages.trainee.table.name": "Nom complet",
  "cp.pages.trainee.table.selected": "sélectionné",
  "cp.pages.trainee.title": "Stagiaires",
  "cp.pages.traineeShares.active": "Actif",
  "cp.pages.traineeShares.addDialogAdd": "Ajouter",
  "cp.pages.traineeShares.addDialogCancel": "Annuler",
  "cp.pages.traineeShares.addDialogDescription": "Entrez le code d'invitation que vous avez reçu de votre organisation partenaire :",
  "cp.pages.traineeShares.addDialogDescription2": "Si vous choisissez de cliquer sur \"Ajouter\", vous reconnaissez que vous acceptez les conditions générales et la politique de confidentialité qui vous sont fournies par l'organisation partenaire avec ce lien/code d'invitation. Il est essentiel de les lire et de les comprendre avant de poursuivre.",
  "cp.pages.traineeShares.addDialogTitle": "Invitation",
  "cp.pages.traineeShares.addShare": "Ajouter Partager",
  "cp.pages.traineeShares.deactivateDialogDescription": "Êtes-vous sûr de vouloir désactiver cet accord de partage avec {instituteName} ?",
  "cp.pages.traineeShares.deactivateDialogNo": "Annuler",
  "cp.pages.traineeShares.deactivateDialogTitle": "Désactiver",
  "cp.pages.traineeShares.deactivateDialogYes": "Désactiver",
  "cp.pages.traineeShares.deactivateTooltip": "Désactiver",
  "cp.pages.traineeShares.endDate": "Date de fin : ",
  "cp.pages.traineeShares.inactive": "Inactive",
  "cp.pages.traineeShares.noActiveItemsMessage": "À l'heure actuelle, vous n'avez accepté aucun accord de partage de données. Appuyez sur le bouton plus en bas à droite pour saisir le code d'invitation correspondant.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Aucun accord de partage en cours.",
  "cp.pages.traineeShares.pageNotFoundMessage": "Les partages de stagiaires que vous recherchez n'existent pas.",
  "cp.pages.traineeShares.pageTitle": "Partages entre stagiaires",
  "cp.pages.traineeShares.pageTitleNotFound": "Introuvable",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Erreur lors de l'ajout de l'invitation : {errorMessage} !",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Erreur lors de la désactivation du partage : {errorMessage} !",
  "cp.pages.traineeShares.snackBarInvalidCode": "Veuillez saisir un code d'invitation valide.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Invitation ajoutée",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Partage désactivé",
  "cp.pages.traineeShares.startDate": "Date de début : ",
  "cp.pages.trainerInvite.errorSnackbar": "L'e-mail est déjà utilisé",
  "cp.pages.trainerInvite.successSnackbar": "Envoyer un e-mail à {email}",
  "cp.pages.trainerInvite.title": "Inviter le formateur",
  "cp.pages.trainers.errorSnackbar": "L'utilisateur n'a pas pu être supprimé. Veuillez réessayer !",
  "cp.pages.trainers.successSnackbar": "Supprimé.",
  "cp.pages.trainersNotAvailable.button": "Inviter le formateur",
  "cp.pages.trainersNotAvailable.message": "Voulez-vous inviter le premier formateur ?",
  "cp.pages.trainersNotAvailable.title": "Pas encore de formateurs !",
  "cp.pages.trainersNotFound.message": "Ce formateur a été supprimé. Désolé :(",
  "cp.pages.trainersNotFound.title": "Formateur non trouvé",
  "cp.pages.trainersTable.deleteLabel": "supprimer",
  "cp.pages.trainersTable.inviteTrainer": "Inviter le Formateur",
  "cp.pages.trainersTable.selected": "sélectionné",
  "cp.pages.trainersTable.tableRowEmail": "E-mail",
  "cp.pages.trainersTable.tableRowName": "Nom",
  "cp.pages.trainersTable.trainers": "Formateurs",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Annuler",
  "cp.pages.userChangeEmail.changeEmail": "Changer l'e-mail",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "E-mail changé",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "Impossible de changer l’e-mail",
  "cp.pages.userChangeEmail.newEmail": "Nouvel e-mail",
  "cp.pages.userChangeEmail.notFound.message": "Cet utilisateur n'existe plus.",
  "cp.pages.userChangeEmail.notFound.title": "Non trouvé.",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "E-mail envoyé",
  "cp.pages.userChangeEmail.verifyEmail.button": "Envoyez-moi un nouvel E-mail de vérification à mon adresse",
  "cp.pages.userChangeEmail.verifyEmail.content": "Nous souhaitons vous tenir au courant des dernières modifications apportées à notre application et à nos produits. C'est pourquoi nous avons besoin de vérifier votre adresse E-mail.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Veuillez vérifier votre E-mail",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Impossible de changer le mot de passe :",
  "cp.pages.userChangePassword.notFound.message": "Cet utilisateur a été supprimé.",
  "cp.pages.userChangePassword.notFound.title": "L'utilisateur est introuvable.",
  "cp.pages.userChangePassword.successSnackbar": "Mot de passe changé",
  "cp.pages.userChangePassword.title": "Changer le mot de passe",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "Le mot de passe actuel est incorrect",
  "cp.pages.userDetails.errorSnackbar": "L'invitation n'a pas pu être envoyée. ",
  "cp.pages.userDetails.invitation": "Invitation",
  "cp.pages.userDetails.notFound.message": "Ces informations ont été supprimées. ",
  "cp.pages.userDetails.notFound.title": "Non Trouvé",
  "cp.pages.userDetails.sendInvitation": "Envoyer l'invitation",
  "cp.pages.userDetails.signUpAccepted": "Accepté",
  "cp.pages.userDetails.signUpPending": "En attente",
  "cp.pages.userDetails.successSnackbar": "Invitation envoyée",
  "cp.pages.userDetails.userDetailsEmail": "E-mail"
}